<template>
  <div class="conteneur contact">
    <div class="sidebar">
      <sidebar />
    </div>
    <div class="contenuDroite">
      <div class="container">
        <h1 class="my-5 text-center">Contact</h1>
        <div class="form_contact mb-4">
          <form data-netlify="true" name="contact" method="post">
            <input type="hidden" name="form-name" value="contact" />
            <div class="text-center my-4">
              <label for="contact_name" class="required">Nom</label>
              <input
                type="text"
                id="contact_name"
                name="name"
                required="required"
                class="form-control mt-2"
                placeholder="Nom"
              />
            </div>
            <div class="text-center my-4">
              <label for="contact_email" class="required">Email</label>
              <input
                type="email"
                id="contact_email"
                name="email"
                required="required"
                class="form-control mt-2"
                placeholder="email"
              />
            </div>
            <div class="text-center my-4">
              <label for="contact_message" class="required">Message</label>
              <textarea
                id="contact_message"
                name="message"
                required="required"
                class="form-control mt-2"
                placeholder="Votre message"
              ></textarea>
            </div>
            <div class="text-center my-4">
              <button class="btn btn-primary" type="submit">Envoyer</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sidebar from "@/components/sidebar.vue";

export default {
  name: "contact",
  components: {
    sidebar,
  },
};
</script>

<style scoped>
h1 {
  font-size: 24px;
  color: #22609e;
}
.conteneur.contact {
  height: 100vh;
}
.conteneur {
  display: flex;
  height: 100%;
}
.contenuDroite {
  flex: 98%;
  text-align: justify;
}
</style>
